import React from 'react';
import { Tag, Typography } from 'antd';
import type { DispatchOrchestration } from './dispatchOrchestration';

const { Text } = Typography;

const PRIORITY_COLORS = {
  critical: 'error',
  high: 'warning',
  medium: 'processing',
  low: 'default'
} as const;

type Props = {
  orchestration: DispatchOrchestration;
};

export const DispatchOrchestrationBanner: React.FC<Props> = ({ orchestration }) => {
  const { workflow, nextActionLabel, nextActionDetail, priority } = orchestration;

  return (
    <div className={`execution-workspace__orchestration execution-workspace__orchestration--${priority}`}>
      <div className="execution-workspace__orchestration-row">
        {workflow.headline ? (
          <Text strong style={{ fontSize: 13 }}>
            {workflow.headline}
          </Text>
        ) : null}
        <Tag color={PRIORITY_COLORS[priority]} style={{ margin: 0 }}>
          {priority === 'critical' ? 'Срочно' : priority === 'high' ? 'Важно' : 'Действие'}
        </Tag>
      </div>
      <div className="execution-workspace__orchestration-next">
        <span className="execution-workspace__muted">Следующее действие: </span>
        <Text strong style={{ fontSize: 13 }}>
          {nextActionLabel}
        </Text>
      </div>
      {nextActionDetail ? (
        <Text className="execution-workspace__muted" style={{ fontSize: 11 }}>
          {nextActionDetail}
        </Text>
      ) : null}
    </div>
  );
};

export default DispatchOrchestrationBanner;
